import { AnimatedBrandLogo } from '@/components/animated-brand-logo';

type AppBrandLogoProps = {
  /** Sidebar réduite : symbole plus compact */
  compact?: boolean;
  className?: string;
};

export function AppBrandLogo({ compact = false, className }: AppBrandLogoProps) {
  return <AnimatedBrandLogo className={className} compact={compact} variant="symbol" />;
}
